import { useTranslation } from "react-i18next";
import Popup from "../../Atoms/Popup";
import H2 from "../../Atoms/H2";
import { Link } from "react-router-dom";
import BlueButton from "../../Atoms/BlueButton";

const PopupGoToSDE24 = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <Popup close={props.close}>
            <H2 className="centered">{i18n.language === "fr" ? "Vous souhaitez vous inscrire au FD100 - 4ème édition ?" : "Do you want to register for the FD100 - 4th edition?"}</H2><br/><br/>
            <Link to="/evenements/learnmore?eid=67590da5499bcc995c210b40"><BlueButton>{i18n.language === "fr" ? "Cliquez ici pour vous inscrire" : "Click here to register"}</BlueButton></Link>
        </Popup>
    )
}

export default PopupGoToSDE24;